// extracted by mini-css-extract-plugin
export default {"country":"visualizationTab_country__C6VDY","removeBtn":"visualizationTab_removeBtn__qCa5s"};